import React, { useState } from 'react';


function Part2({ onPart2Finish, nextSlide, part2Reset}) {

    const [selectedModelType, setSelectedModelType] = useState(false);
    const [selectedVars, setSelectedVars] = useState(false);

    function onModelSelect(event) {
        if (event.target.textContent === "Linear") {
            setSelectedModelType(true);
            if (selectedVars) {
                onPart2Finish();
            }
        }
        if (event.target.textContent === "Market Growth") {
            setSelectedVars(true);
            if (selectedModelType) {
                onPart2Finish();
            }
        }
    }

    return (
        <div>
            <p>Now let's model our data. Modeling just means finding a function that will accurately represent our data. Think of it like finding a line of best fit: the ideal model, when graphed, will connect all our data points smoothly. We will first choose a model type: <strong>Select the "linear" model type.</strong> Because predicting revenue is a complicated task, we use "multiple regression", where we consider other independent variables than just time. <strong>Select the "market growth" variable</strong>, meaning have our model will try to predict revenue using time and the growth rate of the green technology industry.
            </p>
            <div className='model-container'>
                <div className='model-types-wrapper'>
                    <p style={{margin: 0}}>Model Type</p>
                    <div className='model-types'>
                        <button className={selectedModelType ? 'switch-btn selected' : 'switch-btn'} onClick={onModelSelect}>Linear</button>
                    </div>
                </div>
                <div className='independent-vars-wrapper'>
                    <p style={{margin: 0}}>Independent Variables</p>
                    <button className={selectedVars ? 'switch-btn selected' : 'switch-btn'} onClick={onModelSelect}>Market Growth</button>
                </div>
            </div>
            {(!selectedModelType || !selectedVars) && <p className='error'>Select a model type and independent variable</p>}
            {(selectedModelType && selectedVars) && (
                <>
                    <p style={{textAlign:"center"}}><strong>Accuracy: 80.38%</strong></p>
                    <p>Notice the accuracy score above. This score quantifies how well your line fits the points of data. The higher the score, the better. Right now, the accuracy isn't so good right? We will maximize this score in the next part.</p>
                    <button className='primary-btn' onClick={() => {part2Reset();nextSlide();}}>Next</button>
                </>
            )}
        </div>
    )
}

export default Part2;